import { render, staticRenderFns } from "./client.vue?vue&type=template&id=1ac265e1&scoped=true"
import script from "./client.vue?vue&type=script&lang=js"
export * from "./client.vue?vue&type=script&lang=js"
import style0 from "./client.vue?vue&type=style&index=0&id=1ac265e1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ac265e1",
  null
  
)

export default component.exports